module.exports = __webpack_public_path__ + "static/media/team-rocket-3.29305fbd.wav";